import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { useLegacyEffect } from "helper/customHook";

import { Button, Typography } from "@mui/material";
import DetailBg from "assets/background/detail-news-bg.svg";
import { ReactComponent as IconOpenInNew } from "assets/svg/20-open-in-new.svg";
import SkeletonWrapper from "components/common/Skeleton";
import {
  getDetailRRStart,
  resetGetDetailRR,
} from "modules/ResearchReport/redux/getResearchReportDetail";
import {
  detailResearchReportDataSelector,
  detailResearchReportStatusSelector,
} from "modules/ResearchReport/redux/selector";
import pxToRem from "theme/base/pxToRem";
import {
  ButtonWrapper,
  Content,
  Header,
  ReportBox,
  TitleReport,
} from "../styles";
import { decodeHtml, formatDateStringToDDMMYYYY } from "helper/utils";

const ReportDetail = () => {
  const { id } = useParams();
  const data = useSelector(detailResearchReportDataSelector);
  const status = useSelector(detailResearchReportStatusSelector);

  const dispatch = useDispatch();
  useLegacyEffect(() => {
    dispatch(getDetailRRStart({ nodeId: id }));
    return () => {
      dispatch(resetGetDetailRR());
    };
  }, [id]);

  return (
    <SkeletonWrapper
      status={status}
      variant="rectangular"
      width="100%"
      height={pxToRem(500)}
    >
      <ReportBox>
        <Header
          sx={{
            backgroundImage: `url(${DetailBg})`,
            backgroundSize: "cover",
            backgroundPosition: "right",
          }}
        >
          <TitleReport>{decodeHtml(data.text)}</TitleReport>
          <Typography variant="body1" color="white">
            Ngày đăng: {formatDateStringToDDMMYYYY(data.createdDate)}
          </Typography>
        </Header>

        <Content>
          <div
            style={{ overflowX: "auto" }}
            dangerouslySetInnerHTML={{ __html: data.data }}
          />
        </Content>
        <ButtonWrapper>
          <Button
            sx={({ palette }) => ({
              width: pxToRem(246),
              bgcolor: palette.colorsBase.blue_10,
              color: palette.colorsBase.blue_0,
              borderRadius: "100px",
              boxShadow: "none",
              ":hover": {
                bgcolor: palette.colorsBase.blue_10,
              },
            })}
            variant="contained"
            endIcon={<IconOpenInNew />}
            onClick={() => window.open(data.docLink)}
          >
            Xem chi tiết
          </Button>
        </ButtonWrapper>
      </ReportBox>
    </SkeletonWrapper>
  );
};

export default ReportDetail;
